<template>
    <div>
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class="panel profile-panel profile-contact" v-if="roles.is_student">
                    <template v-if="hasParents">
                        <h3 class="text-center tw-mb-10" v-text="$t('wi.parent_information')"></h3>
                        <div id="parentInformation">
                            <div class="team">
                                <edit-button modal-target="editProfile"/>
                                <div class="block-grid-sm-3 block-grid-xs-1 golf-team" id="teamMembers">
                                    <div class="team-member text-left" v-for="parent in parentsData">
                                        <p><strong v-text="parent.title"></strong></p>
                                        <p v-text="parent.name" v-if="parent.name"></p>
                                        <p v-text="parent.phone" v-if="parent.phone"></p>
                                        <p v-if="parent.email">
                                            <a :href="`mailto:${parent.email}`" v-text="parent.email"></a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <empty-state
                            v-else
                            :title="$t('wi.parent_information')"
                            :description="$t('wi.parent_or_guardian_contact_information')"
                            :button="{caption: $t('wi.add_your_parent_info')}"
                            modalTarget='editProfile'
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import {mapGetters} from 'vuex';
    import EmptyState from './EmptyState';
    import EditButton from './VisualElements/EditButton';
    import SocialMediaLink from './VisualElements/SocialMediaLink';

    export default {
        name: 'Parents',
        components: {
            EditButton,
            EmptyState,
            SocialMediaLink
        },
        computed: {
            ...mapGetters({
                roles: 'player-profile/roles',
                parentsData: 'player-profile/parents'
            }),

            hasParents() {
                return this.parentsData !== null && !! this.parentsData.length;
            }
        }
    }
</script>
